import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { FormHeader } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";

const lan = getLanguage();

const Index = ({ data, onChange, onClick, isBorder, item }) => {
  let inputElementPrevious = null;
  let inputElementNext = null;

  inputElementPrevious = (
    <>
      <div
        className={`d-flex flex-column justify-content-start align-items-start ${data.type}`}
        onClick={onClick}
      >
        <div className={"sncmw__header"}>{data.header}</div>
        <div
          className={
            "d-flex flex-row align-items-center  justify-content-start align-items-center"
          }
        >
          {/* {data.imgurl && (
            <img src={data.imgurl} alt="news-img" className={"sncmw__img"} />
          )} */}
          <>
            {data.imgurl && (
              <img
                src={data?.imgurl}
                alt={data?.header}
                className={"sncmw__img"}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            )}
          </>

          <div className={"d-flex flex-column"}>
            <FormHeader
              onClick={onClick}
              data={{
                lan: lan,
                formHeader: data.title,
                size: "xs title",
              }}
            />
            <div className={"sncmw__date"} style={{ marginTop: "-4px" }}>
              {moment(data.created_at).format("MMMM Do YYYY")}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  inputElementNext = (
    <>
      <div className={`d-flex flex-column justify-content-end align-items-end`}>
        <div className={"sncmw__header"}>{data.header}</div>
        <div className={"d-flex flex-row align-items-center"}>
          <div
            className={"d-flex flex-column justify-content-end align-items-end"}
          >
            <FormHeader
              onClick={onClick}
              data={{
                lan: lan,
                formHeader: data.title,
                size: "xs title",
                textAlign: "right",
              }}
            />
            <div className={"sncmw__date"} style={{ marginTop: "-4px" }}>
              {moment().format("MMMM Do YYYY")}
            </div>
          </div>
          {/* <img src={data.imgurl} alt="news-img" className={"sncmw__img"} /> */}
        </div>
      </div>
    </>
  );

  return (
    <>
      <div
        className={`suggest-news-card-main-wrapper ${data.type}  ${data.mainLayerStyles}`}
      >
        {data.type === "previous" && <>{inputElementPrevious}</>}
        {data.type === "next" && <>{inputElementNext}</>}
      </div>
    </>
  );
};

export default Index;
